import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { setPageTitle } from "../../../utils/document";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import PositionIDManagement from "./components/PositionIDManagement";
import AssociateMaster from "./components/AssociateMaster";
import SCGPool from "./components/SCGPool";
import Approvals from "./components/Approvals";
import Reports from "./components/Reports";
import AllAllocations from "./components/AllAllocations";

const PMO_TABS = [
  { id: "position-id-management", label: "Position IDs" },
  { id: "all-allocations", label: "All Allocations" },
  { id: "associate-master", label: "Associate Master" },
  { id: "scg-pools", label: "SCG Pool" },
  { id: "approvals", label: "Approvals" },
  { id: "reports", label: "Reports" },
  { id: "admin", label: "Admin" },
];

const PMODashboard = () => {
  const [searchParams] = useSearchParams();
  const navigate  = useNavigate();
  const tabParam  = searchParams.get("tab");
  const codeParam = searchParams.get("requestCode");

  const [activeTab, setActiveTab] = useState(
    tabParam && PMO_TABS.some((t) => t.id === tabParam) ? tabParam : "position-id-management"
  );
  const [approvalCount, setApprovalCount] = useState(null);
  const [initialRequestCode, setInitialRequestCode] = useState(codeParam ?? null);

  useEffect(() => {
    setPageTitle("PMO Dashboard");
  }, []);

  const handleTabChange = (tab) => {
    if (tab === "admin") {
      navigate("/admin/dashboard");
      return;
    }
    setActiveTab(tab);
  };

  return (
    <DashboardLayout
      tabs={PMO_TABS}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === "position-id-management" && <PositionIDManagement />}
      {activeTab === "all-allocations" && <AllAllocations />}
      {activeTab === "associate-master" && <AssociateMaster />}
      {activeTab === "scg-pools" && <SCGPool />}
      {activeTab === "approvals" && (
        <Approvals
          onSummaryLoad={setApprovalCount}
          initialRequestCode={initialRequestCode}
          onInitialRequestHandled={() => setInitialRequestCode(null)}
        />
      )}
      {activeTab === "reports" && <Reports />}
    </DashboardLayout>
  );
};

export default PMODashboard;